export default "assets/images/icons/roi-b977488b.svg";